import { FC } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import './PageBanner.scss';

interface PageBannerProps {
  message: string;
}

const cnBem = createBemBlockBuilder(['pageBanner']);

export const PageBanner: FC<PageBannerProps> = ({ message }) => (
  <div data-auto="page-banner" className={cnBem()}>
    {message}
  </div>
);
